import { roundHundredRatio } from "./coin-int.ts";

export interface CostGrowthCurve {
  base: string;
  segments: Array<{ from: number; growthBps: number }>;
}

/** 空值沿用旧算法；百分比按万分之一存，0 = 不增长。 */
export function parseCostGrowth(raw: unknown): CostGrowthCurve | null {
  if (raw == null || raw === "") return null;
  const v = typeof raw === "string" ? JSON.parse(raw) : raw;
  if (!v || typeof v !== "object" || typeof v.base !== "string" || v.base.length > 65 || !/^\d+$/.test(v.base) || BigInt(v.base) <= 0n
     || !Array.isArray(v.segments) || !v.segments.length || v.segments.length > 32) throw new RangeError("造价曲线需要正整数首关金额和1～32个分段");
  let prev = 1;
  for (const s of v.segments) {
    if (!s || !Number.isSafeInteger(s.from) || s.from <= prev || !Number.isInteger(s.growthBps)
      || s.growthBps <= -10000 || s.growthBps > 2_147_473_647) throw new RangeError("分段起始关须递增，增长率须大于-100%且精确到0.01%");
    prev = s.from;
  }
  if (v.segments[0].from !== 2) throw new RangeError("第一段须从第2关开始");
  return { base: BigInt(v.base).toString(), segments: v.segments.map((s: { from: number; growthBps: number }) => ({ from: s.from, growthBps: s.growthBps })) };
}

/** 分段连续复利，跨段不取整、实际价覆盖不参与；最后一次取整到百。 */
export function costGrowthAt(curve: CostGrowthCurve, level: number): bigint {
  if (!Number.isSafeInteger(level) || level < 1) throw new RangeError("关卡须为正整数");
  let numerator = BigInt(curve.base), denominator = 1n;
  for (let i = 0; i < curve.segments.length; i++) {
    const s = curve.segments[i];
    const end = Math.min(level, (curve.segments[i + 1]?.from ?? level + 1) - 1);
    const steps = end - s.from + 1;
    if (steps <= 0) break;
    if (!s.growthBps) continue;
    numerator *= BigInt(10000 + s.growthBps) ** BigInt(steps);
    denominator *= 10000n ** BigInt(steps);
  }
  const price = roundHundredRatio(numerator, denominator);
  return price > 0n ? price : 1n;
}
